import {createSelector} from "@reduxjs/toolkit";
import {ReducerStatuses} from "services/utils/utils";

const baseData = state => state.comments.suggest;

export const commentAutosuggestLoadingSelector = createSelector([baseData], (state) => {
    return state.status === ReducerStatuses.LOADING;
});
export const commentAutosuggestShouldHideSelector = createSelector([baseData], (state) => {
    return state.hide || state.search === "";
});
export const commentAutosuggestSearchSelector = createSelector([baseData], (state) => {
    return state.search;
});
export const commentAutosuggestDataSelector = createSelector([baseData], (state) => {
    return state.data;
});
export const commentAutosuggestErrorSelector = createSelector([baseData], (state) => {
    return {
        inError: state.status === ReducerStatuses.ERROR,
        error: state.error
    };
});